import React from 'react';
import {Progress} from 'reactstrap';

import PropTypes from 'prop-types';
import {useMembership} from 'contexts/MembershipContext';
import {SUBSCRIPTION_TYPE_LEVEL} from 'configs/membership';

const PROGRESS_COLORS = {
  default: 'primary',
  warning: 'warning',
  completed: 'danger',
};

ProgressStats.defaultProps = {
  colors: PROGRESS_COLORS,
};

ProgressStats.propTypes = {
  colors: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  value: PropTypes.number.isRequired,
  isLoading: PropTypes.bool.isRequired,
  maxValue: PropTypes.number.isRequired,
};

export function getProgressColor(
  value,
  maxValue,
  colors = {},
  reverse = false,
  limitThreshold
) {
  const percentage = (value / maxValue) * 100;

  if (reverse) {
    if (percentage <= 0) {
      return colors.completed || PROGRESS_COLORS.completed;
    } else if (percentage <= limitThreshold) {
      return colors.warning || PROGRESS_COLORS.warning;
    } else {
      return colors.default || PROGRESS_COLORS.default;
    }
  } else {
    if (percentage === 100 || percentage > 100) {
      return colors.completed || PROGRESS_COLORS.completed;
    } else if (percentage >= limitThreshold) {
      return colors.warning || PROGRESS_COLORS.warning;
    } else {
      return colors.default || PROGRESS_COLORS.default;
    }
  }
}

function ProgressStats(props) {
  const {subscriptionLevel} = useMembership();
  const {isLoading, maxValue, value, colors, reverse} = props;

  let limitThreshold = 0;

  if (subscriptionLevel <= SUBSCRIPTION_TYPE_LEVEL.standard) {
    // lower-tiered plans
    limitThreshold = reverse ? 20 : 80;
  } else {
    // enterprise
    limitThreshold = reverse ? 10 : 90;
  }

  const progressColor = getProgressColor(
    value,
    maxValue,
    colors,
    reverse,
    limitThreshold
  );

  return (
    <Progress
      value={value}
      max={maxValue}
      animated={isLoading}
      barClassName={`bg-${progressColor}`}
    />
  );
}

export default ProgressStats;
